import { useEffect, useState, useCallback } from "react";
import { Row, Spinner } from 'react-bootstrap';
import ReviewCard from "../components/ReviewCard";
import Slider from "react-slick";

function Reviews() {
    const API = process.env.REACT_APP_API_BASE_URL;
    const [reviews, setReviews] = useState([]);
    // const [fetchFeedback, setFetchFeedback] = useState({ success: null, message: "" });
    const [isLoading, setIsLoading] = useState(true);

    const fetchReviews = useCallback(async () => {
        try {
            // setIsLoading(true);
            const response = await fetch(`${API}/reviews/`);
            const data = await response.json();

            if (!response.ok) {
                // setFetchFeedback({ success: false, message: "Unable to fetch reviews." });
                console.error(data);
            }

            setReviews(data);
            // setFetchFeedback({ success: true, message: "" });
        } catch (error) {
            // setFetchFeedback({ success: false, message: "An unexpected error occured fetching reviews." });
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, [API]);

    useEffect(() => {
        fetchReviews();
    }, [fetchReviews]);

    // Determine if there are enough reviews for a proper slider
    const hasEnoughReviewForSlider = reviews.length > 1;

    const sliderSettings = {
        infinite: hasEnoughReviewForSlider, // Infinite if more than 1 review
        speed: 2000,
        slidesToShow: Math.min(reviews.length || 1, 3), // Show max of 3, or actual count, or 1 if no review
        slidesToScroll: 1,
        autoplay: hasEnoughReviewForSlider, // Only autoplay if enough reviews
        autoplaySpeed: 2000,
        arrows: false, // Hide navigation arrows
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1210,
                settings: {
                    slidesToShow: Math.min(reviews.length || 1, 2), // Show max 2, or actual count, or 1 if no reviews
                }
            },
        ]
    };

    return (
        <Row as="section" id="reviews" className="home-section d-flex">
            <Row as="header">
                <h2 className="py-3"><b>WHAT OUR</b> CLIENTS SAY</h2>
            </Row>
            <p>Here's what our clients have to say about us</p>
            {isLoading ? (
                    <div className="text-center mt-5">
                        <Spinner animation="border" variant="primary" className="mx-auto" />
                        <p className="mt-2">Loading reviews...</p>
                    </div>
                ) : (
                    reviews &&
                    <Slider {...sliderSettings} className="py-5">
                        {reviews.map((review, index) => (
                            <ReviewCard key={ index } review={ review } />
                        ))}
                    </Slider>
                )
            }
        </Row>
    )
}

export default Reviews;
